// Packages
import { createSlice } from '@reduxjs/toolkit';
// Redux
import { getUnbilledHoursAsync } from './unbilledHoursThunk';
import { clearReducer } from '../auth/authThunk';
// Interfaces and types
import { IErrorRes } from 'types/appTypes';
import { IGetUnbilledHoursRes } from 'types/unbilledHoursTypes';

interface IState {
  unbilledHours: IGetUnbilledHoursRes | null;
  error: IErrorRes | null;
  isLoading: boolean;
}

const initialState: IState = {
  unbilledHours: null,
  error: null,
  isLoading: false,
};

const unbilledHours = createSlice({
  name: 'unbilledHours',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getUnbilledHoursAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getUnbilledHoursAsync.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.unbilledHours = payload;
    });
    builder.addCase(getUnbilledHoursAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    builder.addCase(clearReducer, () => initialState);
  },
});

export default unbilledHours;
